export default __webpack_public_path__ + "d3a71d08edd6ecd47ded9b35f47f313c.png";